import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function RentalActivityInfoContent() {
  return (
    <>
      <InfoPanelTitle>What is your rental activity?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          The IRS requires you to identify how you participated in your rental
          during the year.
        </p>
        <p>
          How you are involved determines whether the activity is passive or
          non-passive, which affects how you use losses.
        </p>
        <p>Here are your options, ordered from least to most involvement:</p>
        <ol>
          <li>
            <p>
              <strong>Other Passive</strong> Select this if you were not
              involved in managing the rental. Someone else handled the work,
              and you mostly received income.
            </p>
          </li>
          <li>
            <p>
              <strong>Active Rental Real Estate</strong> Choose this if you made
              key decisions, but did not manage the rental on an ongoing basis.
              Examples: approving tenants, authorizing repairs, choosing service
              providers.
            </p>
          </li>
          <li>
            <p>
              <strong>Non-Passive</strong> Pick this if you were regularly
              involved throughout the year, not just making occasional
              decisions. Examples: regularly checking in, coordinating repairs,
              staying closely involved in daily operations.
            </p>
          </li>
          <li>
            <p>
              <strong>Real Estate Professional</strong> Select this if real
              estate was your main line of work.
            </p>
            <p>To qualify:</p>
            <ul>
              <li>
                You spent over 750 hours on real estate activities this year.
              </li>
              <li>
                This work was more than half of all the work you performed.
              </li>
            </ul>
            <p>This may let you deduct more rental losses.</p>
          </li>
        </ol>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Topic no. 425, Passive activities – Losses and credits',
              url: 'https://www.irs.gov/taxtopics/tc425',
            },
            {
              label: 'Publication 925, Passive Activity and At-Risk Rules',
              url: 'https://www.irs.gov/pub/irs-pdf/p925.pdf',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
